module.exports = __webpack_public_path__ + "static/media/plans-mobile.02cb8487.png";